
import React, {Component} from 'react';
import Iframe from '../../components/iframe/iframe';
import styled from 'styled-components';

const Center = styled.div`
  display: flex;
  width: 100%;

height:100%;
  justify-content: flex-start;
  align-items:stretch;
  align-self:center;



`;


    class Deforestation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            src: 'https://resourcewatch.org/embed/map/f14e47f1-fefb-412a-aa40-05a566a13667'
        };
    }

    render() {
        return (
             <Center>
                <Iframe source={this.state.src} />
            </Center>
        );
    }
}

export default Deforestation;